import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { SUBTYPE } from '@kontentino/kontentino-constants/Posts';

export function isInstagramAudioSupported(
  pageType?: number,
  subtype?: number,
): boolean {
  return pageType === TYPE.INSTAGRAM && subtype === SUBTYPE.REEL;
}
